/*
 * @Description: http封装
 */
import FsFetch from '@fubei/mina-fetch'
import logger from './logger'
import getEnv from '../config/index'
import { getRandomString, generateSign } from './utils'
import dayjs from 'dayjs'
const { REQUEST_URL, BACK_REQUEST_URL } = getEnv()

export interface ReqData {
  [x: string]: any
}

export interface Iheader {
  'Content-Type'?: string
  token?: string
}

export interface RequestOptions<D = unknown> {
  url?: string
  data?: D
  method?: 'GET' | 'POST'
  retryTimes?: number
  hasToast?: boolean
  toastTitle?: string
  isMock?: boolean
  contentType?: string
  vendorSn?: string
  noToken?: boolean
  specialError?: boolean
  mockUrl?: string
  sign?: boolean
}

export type Response<T> = {
  code?: number
  message?: string
  success: boolean
  data: T
}

export type BaseResponse<T> = Promise<Response<T>>

const CONTENT_TYPE = 'application/json'
// 加盐
const fsFetch = new FsFetch({
  method: '',
  sign_method: 'md5',
  format: 'json',
  nonce: getRandomString(),
  version: '1.0.0',
  vendor_sn: '', // 动态获取供应商序列号
  salt: '' // 动态获取供应商秘钥
})
/**
 * Timeout 时间
 * @param axiosTimeout
 */
fsFetch.setAxiosTimeout(12000)
/**
 * 设置mock的Url
 */
// fsFetch.setMockUrl(MOCK_URL)
/**
 * 设置备用请求源
 */
fsFetch.setRequerySite([BACK_REQUEST_URL])

/**
 * @function 请求封装
 * @param {*} T
 * @return {*}
 */
export const request = <T = any>(reqOptions: RequestOptions = {}): Promise<T> => {
  const { url, data = {}, sign = true, retryTimes = 2 } = reqOptions
  const defaultOption = {
    isMock: false,
    retryTimes,
    specialError: false,
    method: 'POST',
    ...reqOptions
  }
  const traceId = getRandomString()
  return fsFetch.request({
    url,
    data,
    header: {
      'Content-Type': defaultOption.contentType || CONTENT_TYPE,
      traceId
    },
    baseUrl: REQUEST_URL,
    method: defaultOption.method,
    retryTimes: defaultOption.retryTimes,
    isMock: defaultOption.isMock,
    specialError: defaultOption.specialError,
    startTimeMs: new Date().getTime(),
    sendRawData: !sign
  })
}

/**
 * 自定义请求参数处理方法
 * @param data reqOptions.data
 * @param signParams 加签
 * @param reqOptions 请求的参数
 */
fsFetch.customHandleParams = (data, signParams, reqOptions) => {
  const params = {
    biz_content: typeof data === 'string' ? data : JSON.stringify(data || {}),
    format: signParams.format,
    method: reqOptions.url,
    nonce: signParams.nonce,
    sign_method: signParams.sign_method,
    vendor_sn: wx.getStorageSync('fb_vendorSn') || '', // 动态获取供应商序列号
    version: signParams.version
  }
  const salt = wx.getStorageSync('fb_secret') || ''// 动态获取供应商秘钥
  const sign = generateSign(params, salt)
  return {
    ...params,
    sign
  }
}
/**
 * 成功回调
 * @param error 返回的错误数据
 * @param _reqData 请求的数据
 * @param reqOptions 请求的参数
 */
fsFetch.customSuccessHandle = (result, _reqData, reqOptions, context) => {
  const { hasToast } = reqOptions
  hasToast && wx.hideLoading()
  const endTimeMs = new Date().getTime() // 请求结束时间
  const endTime = dayjs(endTimeMs).format('HH:mm:ss,SSS')
  logger.info({
    ApiHost: context.baseUrl,
    ApiDuration: `${endTimeMs - reqOptions.startTimeMs}ms`,
    ApiMethod: reqOptions.url,
    ApiRequest: reqOptions.data,
    ApiResponse: result.data,
    BizContent: JSON.stringify(_reqData),
    TraceId: reqOptions.header.traceId,
    Content: {
      useTimes: context.useTimes,
      startTime: dayjs(reqOptions.startTimeMs).format('HH:mm:ss,SSS'),
      endTime: endTime
    }
  }, 'OBJECT')
}
/**
 * 错误回调
 * @param error 返回的错误数据
 * @param _reqData 请求的数据
 * @param reqOptions 请求的参数
 */
fsFetch.customErrorHandle = (error, _reqData, reqOptions, context) => {
  const { hasToast, specialError } = reqOptions
  hasToast && wx.hideLoading()
  !specialError && wx.showToast({
    icon: 'none',
    title: error.errorMsg || error.result_message,
    duration: 2000
  })
  const endTimeMs = new Date().getTime() // 请求结束时间
  const endTime = dayjs(endTimeMs).format('HH:mm:ss,SSS')
  logger.error({
    ApiHost: context.baseUrl,
    ApiDuration: `${endTimeMs - reqOptions.startTimeMs}ms`,
    ApiMethod: reqOptions.url,
    ApiRequest: reqOptions.data,
    ApiResponseError: error,
    TraceId: reqOptions.header.traceId,
    Content: {
      useTimes: context.useTimes,
      startTime: dayjs(reqOptions.startTimeMs).format('HH:mm:ss,SSS'),
      endTime: endTime
    }
  }, 'OBJECT')
}

/**
 * complate回调
 * @param error 返回的错误数据
 * @param reqData 请求的数据
 * @param reqOptions 请求的参数
 */
fsFetch.customFinallyHandle = (_res, _reqData, reqOptions) => {
  if (reqOptions.hasToast) {
    wx.hideLoading()
  }
}
